// Paragraph
// =========

import React from 'react'
import style from './index.scss'
import cx from 'classnames'

type ParagraphType = 'large' | 'medium' | 'small'

interface ParagraphProps {
  type?: ParagraphType
  className?: string
  inlineStyles?: React.CSSProperties
  dataTestId?: string
}

const Paragraph: React.FunctionComponent<ParagraphProps> = ({
  children,
  type = 'medium',
  className,
  inlineStyles,
  dataTestId,
}) => {
  return (
    <p
      className={cx(style[type], className)}
      style={inlineStyles}
      data-test-id={dataTestId}
    >
      {children}
    </p>
  )
}
export default Paragraph
